import {EntityModel} from "@fedeltapointofsale/data-client";
import {WebTerminalData} from "./web-terminal.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class WebTerminalEntityModel extends EntityModel<WebTerminalData> {
    constructor(injector: Injector) {
        super(injector, WebTerminalData);
    }

    override onNewEntity(): void {
        this.data.orderReadyEmail.emailMessage.subject = "Order Ready";
        this.data.resetPasswordEmail.emailMessage.subject = "Reset Password";
        this.data.mergeTableOrdersWithinMinutes = 3;
    }
}
``
